import { useState, useEffect } from "react";
import { API } from "./api.js";
const INTERVAL_MILLIS = 60 * 1e3;
function useLegacyInbox() {
  const [legacyNotifications, setLegacyNotifications] = useState([]);
  const [isPolling, setIsPolling] = useState(false);
  async function fetchNotifications() {
    const notifications = await API.getLegacyNotifications();
    setLegacyNotifications(notifications);
  }
  useEffect(() => {
    if (isPolling) {
      return;
    }
    const interval = setInterval(async () => {
      try {
        const hasNew = await API.hasNewLegacyNotifications();
        setIsPolling(true);
        if (hasNew) {
          const legacy = await API.getLegacyNotifications();
          setLegacyNotifications(legacy);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setIsPolling(false);
      }
    }, INTERVAL_MILLIS);
    return () => {
      clearInterval(interval);
    };
  }, []);
  async function readNotification(id) {
    try {
      await API.markAsReadLegacyNotification(id);
      setLegacyNotifications(
        (prev) => prev.map(
          (notification) => notification.id === id ? { ...notification, is_read: true } : notification
        )
      );
    } catch {
      throw new Error(`Failed to mark legacy notification ID: ${id} as read`);
    }
  }
  async function deleteNotification(id) {
    try {
      await API.deleteLegacyNotifications(id);
      setLegacyNotifications((prev) => prev.filter((n) => n.id !== id));
    } catch {
      throw new Error(`Failed to delete legacy notification notification_id: ${id}`);
    }
  }
  return {
    legacyNotifications,
    fetchNotifications,
    readNotification,
    deleteNotification
  };
}
export {
  useLegacyInbox
};
//# sourceMappingURL=useLegacyInbox.js.map
